import React from 'react'

export const TrendingSeeMore = () => {
   return (
      <div  className="calc_minHeight mt-4 container">
         Trending See More
      </div>
   )
}
